import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';


import { ApolloProvider } from "@apollo/client";

import 'assets/scss/commons.scss';
import 'assets/scss/direto.scss';
import 'assets/scss/app.scss';

import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { getApolloClientInstance } from './apollo-client-factory';
import { initStep, Step, getStep } from 'actions/step.action';
import { analyticsReadyCallback } from 'utils/analytics-ready-callback';
import Optimize from 'components/optimize/optimize';
import { OptimizeConfig } from 'components/optimize/optimize-types';
import ErrorBoundary from 'configs/bugsnag';
import { checkLoanApplicationId, getStorage } from 'utils/utils';
import { ProfileProvider } from './providers/profile.provider';
import { APP_PROFILE, SITE_URL, STAGE } from './env';
import partnerAuthorization from 'utils/partner-authorization';
import { ProductProvider } from './providers/product.provider';
import AppRoutes from './app-routes';
import { LoanApplicationProvider } from 'containers/context/useGetLoanApplication';

moment.locale('pt-BR');
const dataLossPopupSteps = [Step.DIRETO, Step.ANALYSE, Step.BIZON];

window.onbeforeunload = () => {
    if (dataLossPopupSteps.includes(getStep())) {
        return confirm('É possível que as alterações feitas não sejam salvas.');
    }

    return null;
};

const callback = async (optimizeConfig: OptimizeConfig) => {

    getStorage().clear();

    const client = await getApolloClientInstance();

    checkLoanApplicationId();

    initStep(Step.DIRETO);

    const basename = APP_PROFILE === 'partners'
        ? '/parceiros/conta/pedido' : '/pedido';

    ReactDOM.render(
        <ErrorBoundary>
            <Optimize config={optimizeConfig}>
                <LoanApplicationProvider>
                    <ProfileProvider>
                        <ProductProvider>
                            <BrowserRouter basename={basename}>
                                <ApolloProvider client={client}>
                                    <AppRoutes />
                                </ApolloProvider>
                            </BrowserRouter>
                        </ProductProvider>
                    </ProfileProvider>
                </LoanApplicationProvider>
            </Optimize>
        </ErrorBoundary>,
        document.getElementById('root')
    );
}

if (APP_PROFILE === 'partners' && STAGE !== 'development' && !partnerAuthorization.isAuthorized()) {
    document.location.href = `${SITE_URL}/pedido/${window.location.search}`;
} else {
    analyticsReadyCallback({ callback });
}
